// inbox/Modal.jsx — 5A-fix2 · البند 1: نافذة واحدة مشتركة لكل نوافذ الصندوق.
//
// السبب الجذري للعطل على iPad: كل نافذة كانت `position:fixed` مرسومة داخل
// شجرة inbox-root. أي سلف (حاوية متمرِّرة/transform/filter — شائع في iOS
// Safari وفي حاويات لوحة الإدارة) يحوّل containing-block العنصر fixed من
// الشاشة إلى تلك الحاوية، فيظهر التظليل جزئياً والنافذة بعيدة عن موضع
// التمرير وزر × خارج حدود الشاشة. الإصلاح: Portal مباشر إلى document.body
// يهرب من كل الأسلاف دفعة واحدة، بصرف النظر عن أي CSS في حاوية التركيب.
//
// حارس معماري: inbox_5a_fix2_modal_guard.test.jsx يفشل إن ظهر
// `position: "fixed"` في أي ملف .jsx آخر داخل src/inbox — كل نافذة جديدة
// (اختيار قالب، عارض صور، ...) يجب أن تُبنى فوق هذا المكوّن.
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { C, Z_MODAL } from "./theme";

export const Modal = ({ open, onClose, title, children, footer,
                         testId = "inbox-modal", closeTestId, wide = false }) => {
  useEffect(() => {
    if (!open) return undefined;
    const html = document.documentElement;
    const body = document.body;
    const prev = { h: html.style.overflow, b: body.style.overflow };
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    return () => {
      html.style.overflow = prev.h;
      body.style.overflow = prev.b;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  const isMobile = typeof window !== "undefined" && window.innerWidth < 720;

  return createPortal(
    <div dir="rtl" data-testid={`${testId}-overlay`}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      style={{ position: "fixed", inset: 0, zIndex: Z_MODAL,
               background: "rgba(0,0,0,0.45)", display: "flex",
               alignItems: isMobile ? "stretch" : "center",
               justifyContent: "center", padding: isMobile ? 0 : 14 }}>
      <div data-testid={testId}
        style={{ background: "#fff", borderRadius: isMobile ? 0 : 18,
                 width: "100%", maxWidth: isMobile ? "100%" : (wide ? 620 : 480),
                 height: isMobile ? "100%" : "auto",
                 maxHeight: isMobile ? "100%" : "88vh",
                 display: "flex", flexDirection: "column",
                 overflow: "hidden", fontFamily: "inherit" }}>
        <div style={{ display: "flex", justifyContent: "space-between",
                      alignItems: "center", padding: "14px 18px",
                      borderBottom: "1px solid #f0f2f5", flexShrink: 0 }}>
          <strong style={{ fontSize: 15 }}>{title}</strong>
          <button type="button" onClick={onClose}
            data-testid={closeTestId || `${testId}-close`}
            style={{ background: "none", border: "none", fontSize: 22,
                     cursor: "pointer", color: C.textMuted, minWidth: 36,
                     minHeight: 36, flexShrink: 0 }} aria-label="إغلاق">×</button>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "14px 18px" }}>
          {children}
        </div>
        {footer && (
          <div style={{ padding: "12px 18px", borderTop: "1px solid #f0f2f5",
                        flexShrink: 0 }}>{footer}</div>
        )}
      </div>
    </div>,
    document.body,
  );
};
